import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./ProductCards.module.scss";
import ImageWithText from "../../atoms/imageWithText/ImageWithText";
import labels from "../../../config/labels";
import types from "../../../config/types";
import Switch from "../../atoms/switch/Switch";
import Checkbox from "../../atoms/checkBox/Checkbox";
import ButtonComponent from "../../atoms/button/ButtonComponent";
import Image from "../../atoms/image/image";
import {
  CustomContainer,
  connect,
  Link,
  useRouter,
} from "../../atoms/DependencyHelper";
import InfoText from "../../atoms/infoText/InfoText";
import errorMessages from "../../../config/errorMessages";
import Tag from "../../atoms/tag/Tag";
import {
  addRemoveProductToCompare,
  showCompareError,
} from "../../../Redux/actions/productCompareAction";
import {
  numberFormat,
  getCookieValue,
  getdealDatenVariant,
  checkIsOutOfStock,
  showSpinner,
  hideSpinner,
  handleCartActionFailure,
  getCustomerActiveCartService,
  setCookieConsentWrapper,
  getAuthToken,
} from "../../../utils/helperServices";
import {
  addSimpleProductToGuestCart,
  addConfigurableToGuestCart,
  addBundleProductToGuestCart,
} from "../../../Redux/actions/cartAction";
import Timer from "../../atoms/timer/Timer";
import SnackBar from "../../atoms/snackBar/SnackBar";
import * as Analytics from "../../../services/analyticsUtag";
import config from "../../../config/index";
import {
  syncUserProfile,
  resetSyncUserProfile,
} from "../../../Redux/actions/userProfileAction";
import { SYNC_USER_PROFILE_SUCCESS } from "../../../Redux/actionTypes/index";

const ProductCards = (props) => {
  const [isTimerOn, setIsTimerOn] = useState(true);
  const handleTimerChange = (newValue) => {
    setIsTimerOn(newValue);
  };

  const [dateTime, dealVariant] = getdealDatenVariant(props);
  let [checked, setCheck] = useState(props?.checked);
  const checkBoxHandler = () => {
    setCheck((checked = !checked));
    props?.checkBoxClickHandler(checked);
  };
  const [isAddedForCompare, setIsAddedForCompare] = useState(false);
  const [showCompareCheck, setShowCompareCheck] = useState(true);
  const [isMonthly, setIsMonthly] = useState(true);
  const [isOnceOff, setIsOnceOff] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [colorAvailable, setColorAvailable] = useState();
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
  const router = useRouter();
  const btnfClicked = () => {
    setIsMonthly(true);
    setIsOnceOff(false);
    props.onPriceTypeChange({
      priceType: types.TYPE_MONTHLY,
      product: {
        ...props.item,
        salesProductPrice: props?.dealProductPrice
      }
    });
  };

  const btnsClicked = () => {
    setIsOnceOff(true);
    setIsMonthly(false);
    props.onPriceTypeChange({
      priceType: types.TYPE_ONCE_OFF,
      product: {
        ...props.item,
        salesProductPrice: props?.minimumPrice
      }
    });
  };

  useEffect(() => {
    const isColorSwatchesAvailable = props?.item?.configurable_options?.[0]?.values;
    const colorAvailable = (isColorSwatchesAvailable !== undefined) && isColorSwatchesAvailable.map((colorItem) => {
      return (
        <li
          style={{ backgroundColor: `${colorItem?.swatch_data?.value}` }}
          key={colorItem.value_index}
          className={styles.color_swatch}>
        </li>
      )
    }
    );
    setColorAvailable(colorAvailable);
  }, [props?.item?.configurable_options])

  useEffect(() => {
    setCheck(props?.checked);
  }, [props?.checked]);

  useEffect(() => {
    if (props?.isMonthly) {
      setIsMonthly(true);
      setIsOnceOff(false);
    }
  }, [props?.isMonthly]);

  useEffect(() => {
    if (props?.isOnceOff) {
      setIsOnceOff(true);
      setIsMonthly(false);
    }
  }, [props?.isOnceOff]);

  const getCustomDropDown = () => {
    if (
      Array.isArray(props?.item?.options) &&
      props?.item?.options.length > 0
    ) {
      const customDropDown = props.item.options.find(
        (option) => option["__typename"] === labels.lbl_custom_dropdown_typeName
      );

      const prepaidOption = customDropDown?.value.find(
        (option) => option.sku === labels.lbl_custom_dropdown_prepaid_option
      );
      return {
        option_id: customDropDown?.option_id,
        option_type_id: prepaidOption?.option_type_id,
      };
    } else {
      return null;
    }
  };
  useEffect(() => {
    if (props?.isAddtoCompare) {
      let compareFlag = false;
      if (props.productCompareList) {
        props.productCompareList.map((product) => {
          if (product.sku === props.item.sku) {
            compareFlag = true;
          }
        });
      }

      setIsAddedForCompare(compareFlag);
      if (props.productCompareList && props.productCompareList.length > 0) {
        const compareObj = props.productCompareList[0];
        let len = compareObj.categories.length;
        for (var i = 0; i < len; i++) {
          let sourceCategory = compareObj.categories[i];
          let isSameCategoryProduct = props.item.categories.filter(
            (category) => category.id === sourceCategory.id
          );
          if (isSameCategoryProduct.length > 0) {
            setShowCompareCheck(true);
            break;
          } else {
            setShowCompareCheck(false);
          }
        }
        if (len == 0 && props.productCompareList[0].sku !== props.item.sku) {
          setShowCompareCheck(false);
        }
      } else {
        setShowCompareCheck(true);
      }
    }
  }, [props?.productCompareList]);

  const checkValidation = (event, isChecked) => {
    let isMobile = window.innerWidth < 768 ? true : false;
    if (props.productCompareList.length > 0 && isChecked) {
      if (isMobile && props.productCompareList.length === 2) {
        props.showCompareError(`${errorMessages.compare_count_mobile_err}`);
        if (event) {
          event.preventDefault();
        }
        setIsAddedForCompare(false);
      } else if (!isMobile && props.productCompareList.length === 3) {
        props.showCompareError(`${errorMessages.compare_count_desktop_err}`);
        if (event) {
          event.preventDefault();
        }
        setIsAddedForCompare(false);
      } else {
        props.addRemoveProductToCompare(isChecked, props.item);
        setIsAddedForCompare(isChecked);
        if (isChecked) {
          Analytics.link({
            page_tool_event: "use",
            page_tool_name: "shopping: product grid: add to compare",
            sales_product_category: [props?.item?.categories[0]?.name],
            sales_product_id: [props?.item?.name],
            sales_product_price: getProductPrice()
              ? [getProductPrice()]
              : [props?.minimumPrice],
            sales_product_quantity: [1],
            sales_order_discount: [props?.amountOff],
          });
        }
      }
    } else {
      props.addRemoveProductToCompare(isChecked, props.item);
      setIsAddedForCompare(isChecked);
      if (isChecked) {
        Analytics.link({
          page_tool_event: "use",
          page_tool_name: "shopping: product grid: add to compare",
          sales_product_category: [props?.item?.categories[0]?.name],
          sales_product_id: [props?.item?.name],
          sales_product_price: getProductPrice()
            ? [getProductPrice()]
            : [props?.minimumPrice],
          sales_product_quantity: [1],
          sales_order_discount: [props?.amountOff],
        });
      }
    }
  };

  const getProductPrice = () => {
    if (props?.finalPriceReq) {
      return props?.finalPrice;
    } else if (isOnceOff) {
      return props?.minimumPrice;
    }
    return props?.dealProductPrice;
  };

  const addCookieProductToCart = async () => {
    showSpinner();
    props?.resetSyncUserProfile();
    const cartId = getCookieValue("cart_id");
    let cartArr, cartResult;

    const analyticsData = {
      sales_event: "cart_add",
      page_name: "shopping: cart",
      page_channel: "shopping",
      page_master_tab: "personal",
      sales_order_discount: [props?.amountOff],
      sales_product_category: [props?.item?.categories?.[0]?.name || ""],
      sales_product_id: [props?.item?.name],
      sales_product_price: [getProductPrice()],
      sales_product_quantity: [1],
      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_subscription_type",
        "visitor_msisdn_hash",
        "visitor_id_hash",
      ]),
    };

    const values = getCustomDropDown();
    const customizable_options = values
      ? [
        {
          id: values?.option_id,
          value_string: values?.option_type_id?.toString(),
        },
      ]
      : [];
    if (props?.item?.promotion_tag_label) {
      analyticsData.sales_promo_name = [props?.item?.promotion_tag_label];
    }
    if (
      props?.item?.__typename === labels.lbl_product_typeName_simple &&
      props?.item?.stock_status === labels.lbl_in_stock
    ) {
      cartArr = [
        {
          data: {
            quantity: labels.lbl_cart_min_product_add_qty,
            sku: props.sku,
          },
          customizable_options: customizable_options,
        },
      ];
      cartResult = await props.addSimpleProductToGuestCart(cartId, cartArr);
      Analytics.link(analyticsData);
    }

    if (props?.item?.__typename === labels.lbl_product_typeName_configurable) {
      cartArr = [
        {
          parent_sku: props?.sku,
          data: {
            quantity: labels.lbl_cart_min_product_add_qty,
            sku: props?.variantSku,
          },
          customizable_options: customizable_options,
        },
      ];
      cartResult = await props.addConfigurableToGuestCart(
        cartId,
        cartArr
      );
      Analytics.link(analyticsData);
    }

    if (
      props?.item?.__typename === labels.lbl_product_type_bundle &&
      props?.item?.stock_status === labels.lbl_in_stock
    ) {
      const bundleOptions = props?.item?.bundleOption?.map((bundle) => {
        const obj = {
          id: bundle.option_id,
          quantity: labels.lbl_cart_min_product_add_qty,
          value: [bundle.options[0].id],
        };
        return obj;
      });
      cartArr = [{
        bundle_options: bundleOptions,
        data: {
          sku: props.sku.toString(),
          quantity: labels.lbl_cart_min_product_add_qty
        },
        customizable_options
      }];

      cartResult = await props.addBundleProductToGuestCart(
        cartId,
        cartArr
      );
      Analytics.link(analyticsData);
    }

    if (cartResult?.status == 422 && props?.isCartPage) {
      handleCartActionFailure(cartResult, addCookieProductToCart, handleProfileSync);
    } else if (
      cartResult &&
      !cartResult.errors &&
      (!cartResult?.data ||
        cartResult?.data?.addConfigurableProductsToCart ||
        cartResult?.data?.addSimpleProductsToCart ||
        cartResult?.data?.addBundleProductsToCart)
    ) {
      hideSpinner();
      props?.setUpdateCartDetails("addedCartProduct");
      setShowSnackBar(true);
    } else {
      hideSpinner();
      props?.setUpdateCartDetails("addedCartProduct");
    }
  };

  const handleProfileSync = async () => {
    const JWTtoken = getCookieValue("vod-web-auth-token");
    const cartId = getCookieValue("cart_id");
    const pageAction = "productCards";

    const dataResult = await props?.syncUserProfile({ JWTtoken, cartId, pageAction });
    if (dataResult.type === SYNC_USER_PROFILE_SUCCESS) {
      if (dataResult.requestPayload.cartId && dataResult.requestPayload.cartId.length) {
        const oAuthToken = getAuthToken(dataResult);
        if (oAuthToken) {
          addCookieProductToCart();
        }
      } else {
        const oAuthToken = getAuthToken(dataResult);

        if (oAuthToken) {
          const getLoggedInCardId = await getCustomerActiveCartService();
          if (getLoggedInCardId && !getLoggedInCardId.fail && getLoggedInCardId.length) {
            setCookieConsentWrapper(
              "cart_id",
              [config.cookie_category.strictly_necessary],
              `document.cookie='cart_id=${getLoggedInCardId};path=/'`
            );

            addCookieProductToCart();
          }
        }
      }
    } else {
      props?.resetSyncUserProfile();
      hideSpinner();
    }
  };

  useEffect(() => {
    if (props?.triggerCallback && props?.triggerCallback == true) {
      addCookieProductToCart();
    }
  }, [props?.triggerCallback]);

  const onProductClick = (event) => {
    if (
      event?.target?.id === "buy-now-btn" ||
      event?.target?.id === "buy-now-label"
    ) {
      props.ctaHandler(props.item);
    } else if (
      event?.target?.id !== "checkbox" &&
      event?.target?.tagName !== "BUTTON" &&
      event?.target?.id !== "addToCompare" &&
      event?.target?.id !== "close" &&
      event?.target?.tagName !== "SPAN"
    ) {
      props.ctaHandler(props.item);
      showSpinner();
      const routerObj =
        isMonthly && !props.isPrepaidOnly
          ? {
            pathname: `${urlPrefix}/product-details/${props.sku}`,
            query: { monthlyPrice: true },
          }
          : {
            pathname: `${urlPrefix}/product-details/${props.sku}`,
          };
      router.push(routerObj).then(() => {
        window.scrollTo(0, 0);
      });
    }
  };

  const handleSnackBar = () => {
    setShowSnackBar(false);
  };

  setTimeout(() => {
    handleSnackBar();
  }, 3000);


  return (
    <>
      {showSnackBar && (
        <SnackBar
          message={labels.lbl_cart_item}
          className={styles.snackBarSpacing}
          closeSnackBar={handleSnackBar}
          isVisible={showSnackBar}
        />
      )}
      <CustomContainer
        className={`${(props?.finalPriceReq && props?.amountOff) ? `${styles["price_promotion"]}` : `${styles["regular_product"]}`}`}
      >

        <CustomContainer
          style={{
            width: !props.isMobile && props.cardWidth,
            minWidth: !props.isMobile && props?.cardMinWidth,
            minHeight: !props.isMobile
              ? !props.finalPriceReq
                ? props.cardHeight
                : props?.cardHeightForOffer
              : "auto",
          }}
          id={`${props?.id}-product-card`}
          className={`${styles["Product-Card"]} ${props?.className} ${props?.customStyle
            } ${isAddedForCompare ? `${styles["product-card-selected"]}` : ""}
				${dealVariant &&
              isTimerOn &&
              (dealVariant == "locked" || dealVariant == "hidden")
              ? `${styles["product-card-non-clickable"]}`
              : ""
            }
			`}
          onClick={
            !props.addToCart ? (event) => onProductClick(event) : undefined
          }
          id={`${props.sku}-productcard`}
        >
          <CustomContainer>
            {props?.closeButtonReq ? (
              <CustomContainer className={styles["close-button"]}>
                <div
                  removeIdClose={props.sku}
                  id="close"
                  className={`${styles["compare-product-close"]}  mt-xs mr-xs pt-m float-right`}
                  onClick={() => props?.handleClose(props.item)}
                ></div>
              </CustomContainer>
            ) : (
              <CustomContainer
                className={
                  !props.isMobile ||
                    props.promotionLabel !== "" ||
                    props?.isLowStock ||
                    props?.isOutOfStock ||
                    props?.amountOff !== "0"
                    ? `${styles["top-section"]} d-flex justify-content-between  align-items-center  pl-xs pr-xs `
                    : `${styles["top-section-without-tag"]}`
                }
              >
                <CustomContainer
                  className={`
                  ${styles["promotion-text-container"]}
                  ${(!props?.isOutOfStock && !props.promotionVariant) && styles["extra_space_align"]}`}
                >
                  {props.promotionText && (
                    <label className={styles["promotion-text"]}>
                      {props.promotionText}
                    </label>
                  )}
                  {props?.finalPriceReq && props?.amountOff && (
                    <label className={styles["promotion-text"]}>
                      {"SAVE R"}
                      {numberFormat(Math.round(props?.amountOff))}
                    </label>
                  )}
                </CustomContainer>
                <CustomContainer className={`${styles["spacing-label"]} `}>
                  {props.promotionLabel !== "" && !props?.item?.promotion_tag &&
                    (!props.isLowStock ||
                      (props?.isLowStock &&
                        props?.item?.display_low_stock_badge == 0)) &&
                    !props.isOutOfStock && 
                    (props?.item?.promotion_tag !== null) ? (
                      <Tag
                        label={props?.promotionLabel}
                        variant={props?.promotionVariant}
                        labelColor={props?.promotionLabelColor}
                        className={props?.offerStyle}
                      />
                    ) : ''}
                  {!props.isOutOfStock &&
                    props?.isLowStock &&
                    props?.item?.display_low_stock_badge == 1 && (
                      <Tag variant="low-stock" className={props?.offerStyle} />
                    )}
                  {props?.isOutOfStock && (
                    <Tag variant="no-stock" className={props?.offerStyle} />
                  )}

                </CustomContainer>
              </CustomContainer>
            )}
          </CustomContainer>
          <CustomContainer className={props.isMobile ? `d-flex ${styles["mobile_product_info_contaier"]}` : `${styles["product_info_contaier"]}`}>
            <CustomContainer
              className={` ${styles["Image-section"]} ${props?.styleImageSection} `}
            >
              {props.isMobile ? (
                <CustomContainer>
                  <Image
                    img_path={props?.itemImage}
                    img_width={
                      props?.imgWidthMobile ? props?.imgWidthMobile : "5.31rem"
                    }
                    img_height={"5.625rem"}
                  />
                </CustomContainer>
              ) : (
                <CustomContainer className={styles.imageWithTextContainer}>
                  <ImageWithText
                    imageLabelStyle={`${styles["image-text-content"]} ${styles["bottom-align"]} ${props?.labelStyle}`}
                    text={props.itemName}
                    img_path={props?.itemImage}
                    width={props.imgWidth}
                    height={props.imgHeight}
                    uniqueName={`${props.sku}-${props.itemName}`}
                  />
                </CustomContainer>
              )}
              {dealVariant && dealVariant != "locked" && isTimerOn ? (
                <CustomContainer
                  className={`${styles["timer-section"]} ${styles[
                    dealVariant === "specialDeals" && "timer-section-background"
                  ]
                    }`}
                >
                  <CustomContainer
                    style={{
                      backgroundColor:
                        dealVariant === "specialDeals"
                          ? props?.endsIn
                          : props?.availableIn,
                    }}
                    className={styles["timer-inner"]}
                    id={`${props?.deal_label}-PC-container`}
                  >
                    <CustomContainer
                      className={styles["timer-text"]}
                      id={`${props?.deal_label}-PC-text`}
                    >
                      {props?.deal_label}
                    </CustomContainer>
                    <Timer
                      dateTime={dateTime}
                      onTimerComplete={handleTimerChange}
                    />
                  </CustomContainer>
                </CustomContainer>
              ) : (
                ""
              )}
            </CustomContainer>
            <CustomContainer
              className={`description ${styles["description-section"]}`}
            >
              {/* Pass custom Props as "mobileLabelClassName" if required. Added "?" so that if we do not pass this prop, code doesn't break */}
              {props.isMobile && (
                <CustomContainer
                  className={`${styles["mobile-label"]} ${props?.mobileLabelClassName}`}
                  style={{ minHeight: props?.mobileLabelMinHeight }}
                >
                  {props.itemName}
                </CustomContainer>
              )}
              {(props?.showColorSwatch === undefined || props?.showColorSwatch) &&
                <CustomContainer>
                  <ul className={styles.color_swatch_container}>
                    {colorAvailable}
                  </ul>
                </CustomContainer>
              }
              {props?.switchReq && !props.isMobile && (
                <CustomContainer
                  className={`${styles["spacing-switch"]} ${props?.hideSwitching ? "d-none" : "d-none"
                    } pt-m`}
                >
                  {props?.isPrepaidOnly ? (
                    <InfoText text={labels.lbl_once_off_only} />
                  ) : (
                    <Switch
                      handleFirst={btnfClicked}
                      handleSecond={btnsClicked}
                      btnfColor={isMonthly}
                      btnSColor={isOnceOff}
                      variant={props?.switchClass ? props?.switchClass : ""}
                    />
                  )}
                </CustomContainer>
              )}

              <CustomContainer className={styles["pricing_section"]}>
                {(!props?.isPrepaidOnly && props?.dealProductPrice) &&
                  <CustomContainer
                    className={`${styles["final-price-monthly"]} ${props?.finalPriseAlignmiddle === true ? "text-center" : ""}`}
                    id={`${props.sku}-FinalPrice`}
                  >
                    {"from "}
                    <span>
                      {"R" + numberFormat(Math.round(props?.dealProductPrice))}
                      {" PM"}
                    </span>
                  </CustomContainer>
                }
                {!props.isMobile && props?.finalPriceReq && (
                  <>
                    <CustomContainer
                      className={`${styles["offer-price-box"]} ${props?.offerPriceClass} ${props?.isPrepaidOnly && styles["single_price_text"]} `}
                    >

                      {!props.showPriceInLine ? (
                        <>

                          <CustomContainer
                            className={
                              (!props.previousPriceReq
                                ? "d-none"
                                : styles["previous-price"])
                            }
                            id={`${props.sku}-PreviousPrice`}
                          >
                            {(!props?.isPrepaidOnly && props?.dealProductPrice) ? "or for " : "for "}
                            <span>R{numberFormat(Math.round(props.minimumPrice))}</span>
                          </CustomContainer>

                          <CustomContainer
                            id={`${props.sku}-FinalPrice`}
                            className={`${styles["final-price"]} ${props?.finalPriceClassLabel}`}
                          >
                            {" R"}
                            {numberFormat(Math.round(props?.finalPrice))}
                          </CustomContainer>

                        </>
                      ) : (
                        <CustomContainer
                          className={styles["single-line-price-box"]}
                          id={`${props.sku}-SinglePrice`}
                        >
                          {checked ? (
                            <span className={styles["offerPrice"]}>+</span>
                          ) : (
                            ""
                          )}

                          <span className={styles["final-price"]} id={props.sku}>
                            {"R" + numberFormat(Math.round(props?.finalPrice))}
                          </span>
                          <span className={styles["previous-price"]}>
                            {" R" + numberFormat(Math.round(props.minimumPrice))}
                          </span>
                        </CustomContainer>
                      )}
                    </CustomContainer>
                    {props?.isPrepaidOnly && (
                      <CustomContainer
                        className={`${styles["once_off_only_text"]}`}
                      >
                        once-off only
                      </CustomContainer>
                    )
                    }
                  </>
                )}

                {props?.priceRequired && !props.finalPriceReq && !props.isMobile && (
                  <CustomContainer
                    id={`${props.sku}-PriceLabel`}
                    className={`
                  ${styles["price-label"]}
                  ${props.isMobile ? "text-left" : "text-center"}
                  ${props?.priceLabelClassName ? props?.priceLabelClassName : ""}
                  ${!props?.isPrepaidOnly ? styles["regular_prices_styles"] : ""}
                  `}
                  >
                    {!props.showPriceInLine &&
                      (isOnceOff || props?.isPrepaidOnly) &&
                      <>{(!props?.isPrepaidOnly && props?.dealProductPrice) && "or "}<span className={styles["hide_in_mobile_only"]}>for </span> <span> R{numberFormat(Math.round(props.minimumPrice))}</span></>}
                    {/* {!props.showPriceInLine &&
                    isMonthly &&
                    !props.isPrepaidOnly &&
                    `from R${numberFormat(
                      Math.round(props?.dealProductPrice)
                    )} PM`} */}
                    {props?.showPriceInLine && checked && (
                      <span className={styles["regularPrice"]}>
                        + R{numberFormat(Math.round(props.minimumPrice))}
                      </span>
                    )}
                    {props?.showPriceInLine && !checked && (
                      <span className={styles["regularPrice"]}>
                        R{numberFormat(Math.round(props.minimumPrice))}
                      </span>
                    )}
                    {props?.isPrepaidOnly && (
                      <CustomContainer
                        className={`${styles["once_off_only_text"]}`}
                      >
                        once-off only
                      </CustomContainer>
                    )
                    }
                  </CustomContainer>
                )}

              </CustomContainer>


              {!props.checkRequired &&
                props?.switchReq &&
                props.isMobile &&
                !props.isPrepaidOnly && (
                  <CustomContainer
                    id={`${props.sku}-PriceLabel`}
                    className={`${styles["price-label"]} ${props.isMobile ? "text-left" : "text-center"
                      }  `}
                  >
                    {`from R${numberFormat(
                      Math.round(props?.dealProductPrice)
                    )} PM`}
                  </CustomContainer>
                )}
              {/* {props?.checkRequired &&
                props?.switchReq &&
                props?.isMobile &&
                !props.isPrepaidOnly && (
                  <CustomContainer
                    id={`${props.sku}-PriceLabel`}
                    className="text-left"
                  >
                    <span className={styles["once-off-mobile-text"]}>
                      {"from "}
                    </span>
                    <span className={styles["price-bold-mobile"]}>
                      {`R${numberFormat(Math.round(props?.dealProductPrice))} PM`}
                    </span>
                  </CustomContainer>
                )} */}
              {!props.checkRequired &&
                props.isMobile &&
                props?.priceRequired &&
                !props.finalPriceReq && (
                  <CustomContainer
                    className={`${styles["special-price"]}
									${props?.priceTextSpacingTopMobile
                        ? props?.priceTextSpacingTopMobile
                        : "mt-xs"
                      } ${props?.isPrepaidOnly ? styles["price-bold"] : ""}`}
                  >
                    {props?.isPrepaidOnly &&
                      `for R${numberFormat(Math.round(props.minimumPrice))}`}
                    {!props.isPrepaidOnly &&
                      `or for R${numberFormat(Math.round(props.minimumPrice))}`}
                  </CustomContainer>
                )}
              {props?.checkRequired &&
                props.isMobile &&
                props.priceRequired &&
                !props.finalPriceReq && (
                  <CustomContainer
                    className={props?.isPrepaidOnly && "mt-xs"}
                  >
                    {props?.isPrepaidOnly && (
                      <>
                        <span className={styles["once-off-mobile-text"]}>
                          {"for "}
                        </span>
                        <span className={styles["price-bold-mobile"]}>
                          {`R${numberFormat(Math.round(props.minimumPrice))}`}
                        </span>
                      </>
                    )}
                    {!props.isPrepaidOnly && (
                      <span className={`${styles["monthly-mobile-text"]} ${styles["regular_prices_styles"]}`}>
                        {`or for R${numberFormat(
                          Math.round(props.minimumPrice)
                        )}`}
                      </span>
                    )}
                    {props?.isPrepaidOnly && (
                      <CustomContainer
                        className={`${styles["once_off_only_text"]}`}
                      >
                        once-off only
                      </CustomContainer>
                    )
                    }
                  </CustomContainer>
                )}
              {!props.checkRequired &&
                props.isMobile &&
                props?.previousPriceReq &&
                props?.finalPriceReq && (
                  <>
                    <CustomContainer
                      className={`${styles["special-price"]}
									${props?.priceTextSpacingTopMobile
                          ? props?.priceTextSpacingTopMobile
                          : "mt-xs"
                        }`}
                      id={`${props.sku}-SpecialPrice`}
                    >
                      {!props.isPrepaidOnly ? "or for " : "for "}
                      <span className={styles["final-price"]}>{`R${numberFormat(
                        Math.round(props?.finalPrice)
                      )} `}</span>
                      <span
                        className={styles["previous-price"]}
                      >{`R${numberFormat(Math.round(props.minimumPrice))}`}</span>
                    </CustomContainer>

                  </>
                )}
              {props?.checkRequired &&
                props?.isMobile &&
                props?.previousPriceReq &&
                props?.finalPriceReq && (
                  <>
                    <CustomContainer
                      className={`${styles["special-price"]} ${props.isPrepaidOnly && styles["once-of-styles"]}`}
                      id={`${props.sku}-SpecialPrice`}
                    >

                      <span className={styles["monthly-mobile-text"]}>
                        {!props.isPrepaidOnly ? "or for " : "for "}
                      </span>
                      {/* {!props.isPrepaidOnly ? "or for " : ""} */}
                      <span
                        className={styles["previous-price"]}
                      ><span>{`R${numberFormat(Math.round(props.minimumPrice))}`}</span></span>
                      <span
                        className={
                          !props.isPrepaidOnly
                            ? styles["monthly-mobile-text"]
                            : styles["once-off-mobile-final-price-text"]
                        }
                      >

                      </span>
                      <span
                        className={
                          !props.isPrepaidOnly
                            ? styles["final-price-with-monthly"]
                            : styles["final-price-mobile"]
                        }
                      >
                        {`R${numberFormat(Math.round(props?.finalPrice))} `}
                      </span>
                      {props?.isPrepaidOnly && (
                        <CustomContainer
                          className={`${styles["once_off_only_text"]}`}
                        >
                          once-off only
                        </CustomContainer>
                      )
                      }

                    </CustomContainer>
                  </>
                )}


            </CustomContainer>

          </CustomContainer>
          {props.checkBoxReq && (
            <CustomContainer
              className={styles["spacing-checkmark-previous"]}
            >
              {props.isAddtoCompare ? (
                <Checkbox
                  id="addToCompare"
                  customSelectStyle={true}
                  isChecked={isAddedForCompare}
                  isHidden={!showCompareCheck}
                  check={`${isAddedForCompare
                    ? `${props.checkedLabel}`
                    : `${props.uncheckedLabel}`
                    }`}
                  click={(event, flag) => checkValidation(event, flag)}
                  uniqueCheckId={props.sku}
                  checkBoxLabelStyling={props?.checkBoxClassName}
                />
              ) : (
                <Checkbox
                  largerCheckSize={props.largerCheckSize}
                  id="checkbox"
                  customSelectStyle={props.customSelectStyle}
                  isChecked={checked}
                  check={`${checked
                    ? `${props.checkedLabel}`
                    : `${props.uncheckedLabel}`
                    }`}
                  click={checkBoxHandler}
                  uniqueCheckId={props.sku}
                />
              )}
            </CustomContainer>
          )}
          <CustomContainer
            className={`${styles[props?.footerSectionClassName]} footer-section`}
          >
            <CustomContainer className="d-flex">
              {props.isMobile && props.checkBoxReq && showCompareCheck && (
                <CustomContainer
                  id="addToCompare"
                  className={`${styles["spacing-button"]}
									${styles[props?.spacingButtonMobileClassName]}
								 border-right d-none`}
                >
                  <CustomContainer
                    id="addToCompare"
                    className={styles["addition-style"]}
                  >
                    {props?.checkRequired && isAddedForCompare && (
                      <Image
                        id="addToCompare"
                        className={`${styles["addToCompare-icon"]} mr-xs-l`}
                        img_path={`${imagePrefix}/assets/images/success-copy-black.svg`}
                      />
                    )}

                    <ButtonComponent
                      id="addToCompare"
                      uniqueButtonId={`${props.sku}-${props.itemName}-addToCompare`}
                      isHidden={!showCompareCheck}
                      selected={isAddedForCompare}
                      selectedText={labels.lbl_added_to_compare}
                      onBtnClick={() => checkValidation(null, !isAddedForCompare)}
                      text={labels.lbl_add_to_compare}
                      textClassName={props.isMobile ? "btnTextSizingMobile" : ""}
                    />
                  </CustomContainer>
                </CustomContainer>
              )}
              {props?.buyNowReq && (
                <Link
                  href={
                    isMonthly && !props.isPrepaidOnly
                      ? `${urlPrefix}/product-details/${props.sku}?monthlyPrice=true`
                      : `${urlPrefix}/product-details/${props.sku}`
                  }
                  legacyBehavior
                >
                  <a className={styles["buy-now-btn"]}>
                    <CustomContainer
                      id="buy-now-button"
                      className={`${styles["spacing-button"]}
                    ${props?.buttonStyleRequired
                          ? styles["button-position"]
                          : ""
                        } ${props?.buttonClassName}
								${styles[props?.spacingButtonMobileClassName]}`}
                    >
                      {props.promotionLabel === types.TYPE_PREORDER ? (
                        <ButtonComponent
                          text={labels.lbl_preorder_now}
                          textClassName={
                            props.isMobile ? "btnTextSizingMobile" : ""
                          }
                          pageRequired="product-details"
                        />
                      ) : (
                        <CustomContainer className={styles["addition-style"]}>
                          {props?.additionRequired && (
                            <Image
                              className="mr-ss"
                              img_path={`${imagePrefix}/assets/images/add-copy.svg`}
                              img_width={"16px"}
                              Height={"16px"}
                            />
                          )}
                          <span
                            className={`${styles["buy-now-label"]} 
													${styles[dealVariant === "hidden" ? "hidden-label" : ""]}
													${styles[props?.isMobile && props?.checkBoxReq ? "buy-now-text-sizing-mobile" : ""]} `}
                            id="buy-now-label"
                          >
                            {props.buttonLabelReq}
                          </span>
                        </CustomContainer>
                      )}
                    </CustomContainer>
                  </a>
                </Link>
              )}
              {props?.addToCart && (
                <CustomContainer
                  className={`${styles["spacing-button"]} ${props["cart-btn-Spacing"]
                    } ${props?.buttonClassName} ${props?.amountOff === "0" ? styles["amount-off-space"] : styles["button-off-space"]
                    }  ${styles[props?.spacingButtonMobileClassName]}`}
                >
                  {props.promotionLabel === types.TYPE_PREORDER ? (
                    <ButtonComponent
                      id={`${props.sku}-${labels.lbl_add_to_cart}`}
                      text={labels.lbl_add_to_cart}
                      textClassName={props.isMobile ? "btnTextSizingMobile" : ""}
                    />
                  ) : (
                    <CustomContainer
                      className={styles["addition-style"]}
                      id={`${props.sku}-${props.buttonLabelReq}`}
                    >
                      {props?.additionRequired && (
                        <Image
                          className={styles["add-img-spacing"]}
                          img_path={
                            checkIsOutOfStock(props?.item)
                              ? `${imagePrefix}/assets/images/add-copy-disabled.svg`
                              : `${imagePrefix}/assets/images/add-copy.svg`
                          }
                          img_width={"16px"}
                          Height={"16px"}
                        />
                      )}
                      <ButtonComponent
                        button
                        text={props.buttonLabelReq}
                        textClassName={
                          props.isMobile ? "btnTextSizingMobile" : ""
                        }
                        onBtnClick={addCookieProductToCart}
                        disabledBtnClassName={
                          checkIsOutOfStock(props?.item)
                            ? "out-of-stock-disabled-btn"
                            : ""
                        }
                        disabledFlag={checkIsOutOfStock(props?.item)}
                      />
                    </CustomContainer>
                  )}
                </CustomContainer>
              )}
            </CustomContainer>
          </CustomContainer>
          {dealVariant && dealVariant == "locked" && isTimerOn ? (
            <CustomContainer
              className={`${styles["timer-section"]} ${styles["locked-timer"]}`}
            >
              <CustomContainer className={styles["timer-inner"]}>
                <CustomContainer
                  className={styles["timer-lock-image"]}
                  id="timerLock-image-PC"
                ></CustomContainer>
                <CustomContainer
                  className={styles["timer-text"]}
                  id={`${props?.deal_label}-locked-PC-text`}
                >
                  {props?.deal_label}
                </CustomContainer>
                <Timer dateTime={dateTime} onTimerComplete={handleTimerChange} />
              </CustomContainer>
            </CustomContainer>
          ) : (
            ""
          )}
        </CustomContainer>

      </CustomContainer>
    </>
  );
};
ProductCards.defaultProps = {
  isMonthly: false,
  isOnceOff: true,
  onPriceTypeChange: () => { },
  ctaHandler: () => { },
};
ProductCards.propTypes = {
  cardWidth: PropTypes.string,
  cardHeight: PropTypes.string,
  imgWidth: PropTypes.string.isRequired,
  imgHeight: PropTypes.string.isRequired,
  labelReq: PropTypes.string,
  isMobile: PropTypes.bool,
  promotionText: PropTypes.string,
  promotionLabel: PropTypes.string,
  minimumPrice: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
  ]),
  itemName: PropTypes.string,
  buttonLabelReq: PropTypes.string,
  productCompareList: PropTypes.array,
  showCompareError: PropTypes.func,
  addRemoveProductToCompare: PropTypes.func,
  item: PropTypes.object,
  isAddtoCompare: PropTypes.bool,
  compareButtonHandler: PropTypes.func,
  sku: PropTypes.string,
  imageUrl: PropTypes.string,
  onPriceTypeChange: PropTypes.func,
  ctaHandler: PropTypes.func,
};

const mapStateToProps = (state) => ({
  productCompareList: state.productCompare.productCompareList,
  totalQuantity: state.cartDetails.totalQuantity,
  userProfileSync: state.userProfileSync,
});

export default connect(mapStateToProps, {
  addRemoveProductToCompare,
  showCompareError,
  addSimpleProductToGuestCart,
  addConfigurableToGuestCart,
  addBundleProductToGuestCart,
  syncUserProfile,
  resetSyncUserProfile,
})(ProductCards);
